<template>
  <div>
    <div class="sidebar-wrapper" style="overflow-y: scroll" id="sidebar-div">
      <div class="sidebar-header">
        <div class="">
          <img style="height: 31px" src="/images/logo-dark.svg" width="180" />
          <!-- <i  class="bx bx-menu"></i> -->
        </div>
      </div>
      <ul class="metismenu" id="menu">
        <!-- <li v-show="$helperService.getLeftMenuAccess('Dashboard')">
          <a id="dashboard" :class="{ active: pageName == 'dashboard' }" style="cursor: pointer"
            v-on:click="$router.push('/dashboard')">
            <img src="/img/dashboard.png" />
             <span class="menu-title" style="font-size: 12px;">Dashboard</span>
          </a>
        </li> -->
        <li v-show="$helperService.getLeftMenuAccess('Manage Users')">
          <a
            id="landingPage"
            :class="{ active: pageName == 'member' }"
            style="cursor: pointer"
            v-on:click="$router.push('/member-list')">
            <img src="/images/manage-user.png" />
            <span class="menu-title" style="font-size: 12px">Manage Users</span>
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Manage Banners')">
          <a
            id="landingPage"
            :class="{ active: pageName == 'banner' }"
            style="cursor: pointer"
            v-on:click="$router.push('/banner')">
            <img src="/images/manage-banner.png" />
            <span class="menu-title" style="font-size: 12px"
              >Manage Banners</span
            >
          </a>
        </li>

        <li
          v-show="$helperService.getLeftMenuAccess('Manage Subscription Plan')">
          <a
            id="admin"
            :class="{ active: pageName.includes('subscription-plan') }"
            style="cursor: pointer"
            v-on:click="$router.push('/subscription-plan')">
            <img src="/images/subscription-plan.png" />
            <span class="menu-title" style="font-size: 12px"
              >Manage Subscription Plan</span
            >
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Success Stories')">
          <a
            id="content"
            :class="{ active: pageName.includes('success-stories') }"
            style="cursor: pointer"
            v-on:click="redirectTo()">
            <img src="/images/Success Stories.png" />
            <span class="menu-title" style="font-size: 12px"
              >Success Stories</span
            >
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Manage Geographical')">
          <a
            id="content"
            :class="{ active: pageName.includes('geographical') }"
            style="cursor: pointer"
            v-on:click="$router.push('/geographical')">
            <img src="/images/manage- geographical.png" />
            <span class="menu-title" style="font-size: 12px"
              >Manage Geographical</span
            >
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Settings')">
          <a
            id="content"
            :class="{ active: pageName.includes('setting') }"
            style="cursor: pointer"
            v-on:click="$router.push('/setting')">
            <img src="/images/setting.png" />
            <span class="menu-title" style="font-size: 12px">Settings</span>
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Reports')">
          <a
            id="content"
            :class="{ active: pageName.includes('report') }"
            style="cursor: pointer"
            v-on:click="$router.push('/report')">
            <img src="/images/reports.png" />
            <span class="menu-title" style="font-size: 12px">Reports</span>
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Manage staff')">
          <a
            id="admin"
            :class="{ active: pageName.includes('admin') }"
            style="cursor: pointer"
            v-on:click="$router.push('/admin')">
            <img src="/images/manage-admin.png" />

            <span class="menu-title" style="font-size: 12px">Manage Staff</span>
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Manage Dropdown Menu')">
          <a
            id="admin"
            :class="{ active: pageName.includes('dropdown') }"
            style="cursor: pointer"
            v-on:click="$router.push('/dropdown-menu')">
            <img src="/images/Dropdown.png" />
            <span class="menu-title" style="font-size: 12px"
              >Manage Dropdown Menu</span
            >
          </a>
        </li>
        <li v-show="$helperService.getLeftMenuAccess('Manage Roles')">
          <a
            id="role"
            :class="{ active: pageName.includes('role') }"
            style="cursor: pointer"
            v-on:click="$router.push('/role')">
            <img src="/images/manage-role.png" />
            <span class="menu-title" style="font-size: 12px">Manage Roles</span>
          </a>
        </li>
        <!-- <li v-show="$helperService.getLeftMenuAccess('Delete Profile Request')">
          <a
            id="role"
            :class="{ active: pageName.includes('delete-profile') }"
            style="cursor: pointer"
            v-on:click="$router.push('/delete-profile')"
          >
            <img src="/images/manage-role.png" />
             <span class="menu-title" style="font-size: 12px;">Delete Profile Request</span>
          </a>
        </li> -->
        <li v-show="$helperService.getLeftMenuAccess('Notification')">
          <a
            id="role"
            :class="{ active: pageName.includes('notification') }"
            style="cursor: pointer"
            v-on:click="$router.push('/notification')">
            <img src="/images/manage-role.png" />
            <span class="menu-title" style="font-size: 12px"
              >Notifications</span
            >
          </a>
        </li>
      </ul>
    </div>
    <header class="top-header">
      <nav class="navbar navbar-expand">
        <div class="left-topbar d-flex align-items-center">
          <a href="javascript:;" class="toggle-btn">
            <i class="bx bx-menu"></i>
          </a>
        </div>
        <div class="right-topbar ml-auto">
          <ul class="navbar-nav" style="max-height: 60px !important">
            <li class="nav-item dropdown dropdown-user-profile">
              <a
                style="max-height: 60px !important"
                class="nav-link dropdown-toggle dropdown-toggle-nocaret p-0"
                href="javascript:;"
                data-toggle="dropdown">
                <div class="media user-box align-items-center">
                  <div class="media-body user-info">
                    <p class="user-name mb-0" id="loginuser-name">
                      {{ details.first_name }} {{ details.last_name }}
                    </p>
                  </div>
                  <img
                    :src="details.image ? details.image : '/img/user-pic.png'"
                    class="user-img"
                    alt="user avatar"
                    id="loginuser-image" />
                </div>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <router-link to="/my-profile">
                  <a class="dropdown-item">
                    <i class="bx bx-user"></i>
                    <span>Profile</span>
                  </a>
                </router-link>
                <div class="dropdown-divider mb-0"></div>
                <a
                  class="dropdown-item"
                  style="cursor: pointer"
                  v-on:click="logout">
                  <i class="bx bx-power-off"></i>
                  <span>Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  </div>
</template>
<script>
import api from "../services/WebService";
export default {
  name: "Menu",
  data() {
    return {
      pageName: "",
      details: {},
      isShow: false,
    };
  },
  watch: {
    "$route.fullPath"(newValue) {
      var pathname = newValue.replace("/", "");
      this.pageName = pathname;
    },
  },
  mounted() {
    this.pageName = this.$route.fullPath.replace("/", "");
    console.log("object", this.details.first_name);
    this.getLoginUserDetail();
  },
  methods: {
    redirectTo() {
      localStorage.removeItem("tab");
      this.$router.push("/success-stories");
    },
    isShowList() {
      this.isShow = !this.isShow;
    },
    logout() {
      api
        .postAPI({
          _action: "/unregister/device/token",
        })
        .then(() => {
          localStorage.clear();
          this.$router.push("/login");
        })
        .catch(() => {});
    },
    getLoginUserDetail() {
      api
        .getAPI({
          _action: "/me",
        })
        .then((res) => {
          // if (res.role != "ADMIN") {
          //   this.$notify({
          //     type: "success",
          //     text: "You don't have access ",
          //   });
          // }

          // if (window.location.pathname == "/access-denied") {
          //   this.$router.go(-1);
          // }
          if (res.access && res.access.length > 0) {
            this.$helperService.setAccessLevel(res.access);
          }
          this.details = res;
        })
        .catch(() => {});
    },
  },
};
const accSingleTriggers = document.querySelectorAll(".js-acc-single-trigger");
accSingleTriggers.forEach((trigger) =>
  trigger.addEventListener("click", toggleAccordion)
);

function toggleAccordion() {
  const items = document.querySelectorAll(".js-acc-item");
  const thisItem = this.parentNode;
  items.forEach((item) => {
    if (thisItem == item) {
      thisItem.classList.toggle("is-open");
      return;
    }
    item.classList.remove("is-open");
  });
}
</script>
